module.exports = __webpack_public_path__ + "officialStatic/img/n9.caa0262.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/n9.jpg
// module id = Gs2+
// module chunks = 0